<!--  -->
<template>
  <div>
    <div class="cont_r_b11">
      <p>
        <b style="line-height:1.5;">
          <span style="font-size:18px;font-family:宋体;">Electrode</span>
        </b>
      </p>
      <p>
        <span style="font-family:宋体;text-indent:18pt;line-height:1.5;">Round Electrode：</span>
      </p>
      <p>
        <span style="text-indent:18pt;line-height:1.5;font-family:宋体;">Carbon Electrode</span>
        <span style="text-indent:18pt;line-height:1.5;font-family:Arial;">:</span>
        <span style="text-indent:18pt;line-height:1.5;font-family:宋体;">Diameter</span>
        <span style="text-indent:18pt;line-height:1.5;font-family:Arial;">800mm</span>
        <span style="text-indent:18pt;line-height:1.5;font-family:Arial;">– 1272mm</span>
      </p>
      <p>
        <span style="line-height:1.5;font-family:宋体;">Graphite Electrode</span>
        <span style="line-height:1.5;font-family:Arial;">:</span>
        <span style="line-height:1.5;font-family:宋体;">Diameter</span>
        <span style="line-height:1.5;font-family:Arial;">800mm</span>
        <span style="line-height:1.5;font-family:Arial;">-1146mm</span>
      </p>
      <p>
        <img :src="images.tszp">
      </p>
      <p>
        <br>
      </p>
      <p>
        <span style="line-height:1.5;font-family:宋体;">Packet：</span>
        <span style="line-height:1.5;font-family:Arial;">914X762X3556mm</span>
      </p>
      <p style="text-align:left;" align="left">
        <span style="font-size:12.0pt;font-family:Arial;">
          <span></span>
        </span>
        <span style="font-size:12.0pt;font-family:宋体;"></span>
      </p>
      <table
        style="text-align:center;border-collapse:collapse;border:none;"
        border="1"
        cellpadding="0"
        cellspacing="0"
      >
        <tbody>
          <tr>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="79">
              <p style="text-align:center;">
                <b>
                  <span style="font-family:宋体;font-size:12px;">Technical parameters</span>
                </b>
                <b>
                  <span style="font-size:10.0pt;font-family:&quot;"></span>
                </b>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="96">
              <p style="text-align:center;">
                <b>
                  <span style="font-size:12px;font-family:宋体;">Value</span>
                </b>
                <b>
                  <span style="font-size:10.0pt;font-family:&quot;"></span>
                </b>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="96">
              <p style="text-align:center;">
                <b>
                  <span style="font-size:12px;font-family:宋体;">Typical Value</span>
                </b>
                <b>
                  <span style="font-size:10.0pt;font-family:&quot;"></span>
                </b>
              </p>
            </td>
          </tr>
          <tr>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="79">
              <p style="text-align:center;">
                <span style="font-size:12px;font-family:宋体;">Real density</span>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="96">
              <p style="text-align:center;">
                <span style="font-size:12px;font-family:'} ';">2.00g</span>
                <span style="font-size:12px;font-family:'} ';">/cm3 Min</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="96">
              <p style="text-align:center;">
                <span style="font-size:12px;font-family:'} ';">&nbsp;</span>
              </p>
            </td>
          </tr>
          <tr>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="79">
              <p style="text-align:center;">
                <span style="font-size:12px;font-family:宋体;">Bulk density</span>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="96">
              <p style="text-align:center;">
                <span style="font-size:12px;font-family:'} ';">1.54g</span>
                <span style="font-size:12px;font-family:'} ';">/cm3 Min</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="96">
              <p style="text-align:center;">
                <span style="font-size:12px;font-family:'} ';">1.55-1.56g/cm3</span>
              </p>
            </td>
          </tr>
          <tr>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="79">
              <p style="text-align:center;">
                <span style="font-size:12px;font-family:宋体;">Flexual strength</span>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="96">
              <p style="text-align:center;">
                <span style="font-size:12px;font-family:'} ';">
                  6MPa
                  Min
                </span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="96">
              <p style="text-align:center;">
                <span style="font-size:12px;font-family:'} ';">7MPa</span>
              </p>
            </td>
          </tr>
          <tr>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="79">
              <p style="text-align:center;">
                <span style="font-size:12px;font-family:宋体;">Compressive strength</span>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="96">
              <p style="text-align:center;">
                <span style="font-size:12px;font-family:'} ';">
                  23MPa
                  Min
                </span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="96">
              <p style="text-align:center;">
                <span style="font-size:12px;font-family:'} ';">25-26MPa</span>
              </p>
            </td>
          </tr>
          <tr>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="79">
              <p style="text-align:center;">
                <span style="font-size:12px;font-family:宋体;">Resistivity</span>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="96">
              <p style="text-align:center;">
                <span style="font-size:12px;font-family:'} ';">
                  14μΩm
                  Max
                </span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="96">
              <p style="text-align:center;">
                <span style="font-size:12px;font-family:'} ';">12-13μΩm</span>
              </p>
            </td>
          </tr>
          <tr>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="79">
              <p style="text-align:center;">
                <span style="font-size:12px;font-family:宋体;">Porosity</span>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="96">
              <p style="text-align:center;">
                <span style="font-size:12px;font-family:'} ';">
                  28.7%
                  Max
                </span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="96">
              <p style="text-align:center;">
                <span style="font-size:12px;font-family:'} ';">&nbsp;</span>
              </p>
            </td>
          </tr>
          <tr>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="79">
              <p style="text-align:center;">
                <span style="font-size:12px;font-family:宋体;">Ash</span>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="96">
              <p style="text-align:center;">
                <span style="font-size:12px;font-family:'} ';">
                  2.3%
                  Max
                </span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="96">
              <p style="text-align:center;">
                <span style="font-size:12px;font-family:'} ';">&nbsp;</span>
              </p>
            </td>
          </tr>
          <tr>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="79">
              <p style="text-align:center;">
                <span style="font-size:12px;font-family:'} ';">Fe</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="96">
              <p style="text-align:center;">
                <span style="font-size:12px;font-family:'} ';">
                  2.07%
                  Max
                </span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="96">
              <p style="text-align:center;">
                <span style="font-size:12px;font-family:'} ';">&nbsp;</span>
              </p>
            </td>
          </tr>
          <tr>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="79">
              <p style="text-align:center;">
                <span style="font-size:12px;font-family:'} ';">S</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="96">
              <p style="text-align:center;">
                <span style="font-size:12px;font-family:'} ';">
                  0.05%
                  Max
                </span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="96">
              <p style="text-align:center;">
                <span style="font-size:12px;font-family:'} ';">&nbsp;</span>
              </p>
            </td>
          </tr>
        </tbody>
      </table>

      <p></p>
      <p style="text-align:center;">
        <span style="font-size:10.0pt;font-family:&quot;">
          <br>
        </span>
      </p>
      <span style="font-size:12.0pt;font-family:宋体;"></span>
      <p>
        <br>
      </p>
      <p>
        <br>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      images: {
        tszp: require("../../../assets/img/common/tszp.jpg")
      }
    };
  },

  components: {},

  methods: {}
};
</script>
<style lang='stylus' rel='stylesheet/stylus'>
</style>


// WEBPACK FOOTER //
// src/components/ew/product/tszp.vue